import countryCodesList from '@constants/countryCodes.json';

const countryCodes = countryCodesList
  ?.map(code => {
    return {
      name: `${code?.code} (+${code?.dialCode})`,
      id: code?.dialCode,
      code: code?.code,
    };
  })
  .sort((a, b) => {
    if (a?.code?.toLowerCase() < b?.code?.toLowerCase()) return -1;
    if (a?.code?.toLowerCase() > b?.code?.toLowerCase()) return 1;
    return 0;
  });

const findCountryCode = (code = "") => {
    return countryCodesList.find(({dialCode}) => dialCode == code);
}

export { countryCodes , findCountryCode};
